﻿import './sections.css'
const PROBLEMS = [
  { icon: '🔗', title: 'Disconnected Tools', text: 'Recruiters screen in one system. Learning teams run training in another platform. Managers lack visibility into workforce competencies.' },
  { icon: '📊', title: 'Siloed Data', text: 'Hiring data lives separately from training. Training data disconnected from performance. No complete picture of workforce capability.' },
  { icon: '💡', title: 'No Intelligence', text: "You know who you hired, but not their actual capabilities. Can't predict performance gaps or identify skill needs until it's too late." },
  { icon: '💸', title: 'Expensive & Inefficient', text: 'PossoBuild replaces these fragmented systems with one unified conversational AI platform.' },
]
const STATS = [
  { n: '44 days', l: 'Average time-to-fill' },
  { n: '$4,700', l: 'Cost per hire' },
  { n: '46%', l: 'New hires fail within 18 months' },
  { n: '60%', l: 'Of HR time spent on admin' },
]
export default function ProblemSection() {
  return (
    <section className="problem-section section">
      <div className="container">
        <h2 className="section-title">The HR Tech Stack Is Broken</h2>
        <p className="section-subtitle">Organizations today rely on disconnected tools for hiring, training, skills assessment, and employee support.</p>
        <div className="problem-grid">
          {PROBLEMS.map(p => (
            <div key={p.title} className="problem-card">
              <div className="problem-icon">{p.icon}</div>
              <h3>{p.title}</h3>
              <p>{p.text}</p>
            </div>
          ))}
        </div>
        <div className="stats-row">
          {STATS.map(s => (
            <div key={s.l} className="stat">
              <div className="stat-number">{s.n}</div>
              <div className="stat-label">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

